import { Component } from '@angular/core';
import { ProfileInfo } from "./profile-info/profile-info";

@Component({
  selector: 'app-update-profile-component',
  imports: [ProfileInfo],
  templateUrl: './update-profile-component.html',
  styleUrl: './update-profile-component.scss'
})
export class UpdateProfileComponent {

}
